import { render, staticRenderFns } from "./PershingKYC.vue?vue&type=template&id=da622fdc&scoped=true"
import script from "./PershingKYC.vue?vue&type=script&lang=js"
export * from "./PershingKYC.vue?vue&type=script&lang=js"
import style0 from "./PershingKYC.vue?vue&type=style&index=0&id=da622fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da622fdc",
  null
  
)

export default component.exports